import { render, staticRenderFns } from "./EventUpgrade.vue?vue&type=template&id=6cbd9003&scoped=true&"
import script from "./EventUpgrade.vue?vue&type=script&lang=js&"
export * from "./EventUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd9003",
  null
  
)

export default component.exports